import React, { useCallback } from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices, Button,
    Edit, SimpleForm, TextInput,Create,
    DateInput, BooleanInput, NumberInput, FileInput, FileField, ReferenceInput,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton, SelectInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { useForm } from 'react-final-form';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../common/apiClient";
import { FormToolbar } from "../../common/FormToolbar";
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from "../../formStyles";

const RealizationDocumentEdit = props => {
    const classes = useStyles({});
    console.log(props);
    const handleSubmit = async (formdata) => {
        console.log(formdata);
        let documentUrl = await apiClient.UploadFile("docUrl", formdata.docUrl);
        let data = props.record;
        data.docUrl = documentUrl;
        data.modifyBy = 1;
        data.modifyDate = data.createdDate;
        apiClient.updateRealizationDocument(data).then(res => {
            props.onClose();
        }).catch(err => {
            console.log(err);
        });
        // apiClient.updateAccountServiceCategoryMap(data).then(res => {
        //     console.log(res);
        //     props.onClose();
        // }).catch(err => {
        //     console.log(err);
        // });
    }
    return (
        <Create {...props} resource="realiz-ord-dets" redirect="false">
            <SimpleForm
                onSubmit={handleSubmit}
                toolbar={<FormToolbar label="Save" onSave={handleSubmit} onClose={props.onClose} onCancel={props.onCancel} />}
                variant="outlined">

                <FileInput fullWidth={true} source="docUrl" label="Document" accept="application/pdf,application/vnd.ms-powerpoint">
                    <FileField source="docUrl" title="Document" />
                </FileInput>
            </SimpleForm>
        </Create>
    );
}
export default RealizationDocumentEdit;